import LocomotiveScroll from 'locomotive-scroll';

$(function() {
    $('[data-scroll-speed]').attr('data-scroll', 'true');
    $('[data-scroll-speed]').attr('data-scroll-enable-touch-speed', 'true');

    const scroll = new LocomotiveScroll({
        lenisOptions: {
            allowNestedScroll: true
        }
    });
})